import React, { useState, useEffect, useCallback } from "react";
import { MDBDataTable } from "mdbreact";
import "../../../../src/assets/css/custom.css";
import { FormCheck } from "react-bootstrap";
import axios from "axios";
import { localserver } from "../../../api/common";
import PreviewAttendeeOrderModal from "./PreviewAttendeeOrder";
import UpdateAttendeeModal from "./UpdateAttendeeModel";
import {
  FaCheckCircle,
  FaRupeeSign,
  FaFilter,
  FaShoppingCart,
  FaChevronRight,
} from "react-icons/fa";
import { showToast, ToastMessage } from "../../Shared/ToastMessage";
import { useUser } from "../../AdminUsers/UserContext";

const EventOrderList = () => {
  const { checkPermission } = useUser();
  const [activeTab, setActiveTab] = useState("confirmed");
  const [rows, setRows] = useState([]);
  const [selectedTicketId, setSelectedTicketId] = useState("0");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [statusSummary, setStatusSummary] = useState({
    confirmed: 0,
    pending: 0,
    blacklisted: 0,
    cancelled: 0,
  });
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedPreviewOrder, setSelectedPreviewOrder] = useState({});
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateAttendeeDetails, setUpdateAttendeeDetails] = useState({});
  const [ticketList, setTicketList] = useState([]);
  const [updateType, setUpdateType] = useState("attendee");
  const [checkUserLoading, setCheckUserLoading] = useState(false);

  const [filterTicketId, setFilterTicketId] = useState("0");
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");

  const parseBuyerDetails = (buyerDetails) => {
    try {
      const parsed = JSON.parse(buyerDetails || "{}");
      return parsed.custom_fields || [];
    } catch (error) {
      console.error("Error parsing buyer_details:", error);
      return [];
    }
  };

  const getOrdersByEventID = async (
    {
      status = "all",
      ticket_id = "0",
      from_date = "",
      to_date = "",
      search = "",
    } = {},
    setList = true
  ) => {
    try {
      const response = await axios.post(
        `${localserver}/getOrderByEventId`,
        {
          event_id: localStorage.getItem("eventId"),
          status,
          ...(ticket_id !== "0" && { ticket_id }),
          from_date,
          to_date,
          search,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.success) {
        
        const attendees = response.data.attendees || [];
        if (setList) {
          const orderRows = attendees.map((attendee) => {
            const buyerDetails = attendee.buyer_details
              ? parseBuyerDetails(attendee.buyer_details)
              : [];
            const firstName =
              buyerDetails.length > 0
                ? buyerDetails.find(
                    (f) => f.name === "first_name" || f.label === "First Name"
                  )?.value || attendee.first_name
                : attendee.first_name;
            const lastName =
              buyerDetails.length > 0
                ? buyerDetails.find(
                    (f) => f.name === "last_name" || f.label === "Last Name"
                  )?.value || attendee.last_name
                : attendee.last_name;

            return {
              orderId: attendee.id,
              date: new Date(attendee.payment_date).toLocaleDateString(),
              nameOfBuyer:
                `${firstName || ""} ${lastName || ""}`.trim() || "Unknown",
              tickets: `${
                attendee.ticket_count > 1
                  ? "Ticket *" + attendee.ticket_count
                  : attendee.ticket_name
              }`,
              amount: `${attendee.currency} ${attendee.total_amount}`,
              refundOrDues:
                attendee.payment_status === "Success" ? "Paid" : "Pending",
              method: attendee.payment_method || "--",
              status: attendee.status,
              checked: false,
              attendeeData: {
                ...attendee,
                buyer_details: attendee.buyer_details || "",
              },
            };
          });
          setRows(orderRows);
        }
        if (status === "all") {
          const statusCounts = response.data.statusSummary.reduce(
            (acc, item) => ({
              ...acc,
              [item.status]: item.count,
            }),
            { confirmed: 0, pending: 0, blacklisted: 0, cancelled: 0 }
          );
          setStatusSummary(statusCounts);
          const tempRows = attendees.map((attendee) => {
            const buyerDetails = attendee.buyer_details
              ? parseBuyerDetails(attendee.buyer_details)
              : [];
            const firstName =
              buyerDetails.length > 0
                ? buyerDetails.find(
                    (f) => f.name === "first_name" || f.label === "First Name"
                  )?.value || attendee.first_name
                : attendee.first_name;
            const lastName =
              buyerDetails.length > 0
                ? buyerDetails.find(
                    (f) => f.name === "last_name" || f.label === "Last Name"
                  )?.value || attendee.last_name
                : attendee.last_name;
            return {
              orderId: attendee.id,
              date: new Date(attendee.payment_date).toLocaleDateString(),
              nameOfBuyer:
                `${firstName || ""} ${lastName || ""}`.trim() || "Unknown",
              tickets: `${attendee.ticket_name} ${
                attendee.ticket_count > 1 ? "*" + attendee.ticket_count : ""
              }`,
              amount: `${attendee.currency} ${attendee.total_amount}`,
              refundOrDues:
                attendee.payment_status === "Success" ? "Paid" : "Pending",
              method: attendee.payment_method || "--",
              status: attendee.status,
              checked: false,
              attendeeData: {
                ...attendee,
                buyer_details: attendee.buyer_details || "",
              },
            };
          });
          const revenue = tempRows.reduce((sum, row) => {
            if (row.status !== "confirmed" || !row.amount.includes("INR")) {
              return sum;
            }

            const amountStr = row.amount.replace(/[^0-9.]/g, "");

            const amount = Number.parseFloat(amountStr);

            return sum + (Number.isNaN(amount) ? 0 : amount);
          }, 0);
          setTotalRevenue(revenue);
        }
      } else {
        console.error(
          "Error: Failed to fetch order data - Response:",
          response.data
        );
        if (setList) {
          setRows([]);
        }
      }
    } catch (error) {
      console.error("Error fetching order data:", error);
      if (setList) {
        setRows([]);
      }
    }
  };

  const fetchTicketList = async () => {
    try {
      const response = await axios.post(
        `${localserver}/get_ticket_by_event_id`,
        {
          event_id: localStorage.getItem("eventId"),
          ticket_status: "all",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.success) {
        
        setTicketList(response.data.tickets || []);
      } else {
        console.error(
          "Error: Failed to fetch ticket list - Response:",
          response.data
        );
        setTicketList([]);
      }
    } catch (error) {
      console.error("Error fetching ticket list:", error);
      setTicketList([]);
    }
  };

  const fetchOrders = useCallback(() => {
    getOrdersByEventID(
      {
        status: activeTab,
        ticket_id: selectedTicketId,
        from_date: dateFrom,
        to_date: dateTo,
        search: searchQuery,
      },
      true
    );
  }, [activeTab, selectedTicketId, dateFrom, dateTo, searchQuery]);

  const refreshSummary = useCallback(() => {
    getOrdersByEventID({ status: "all" }, false);
  }, []);


  const cancelOrder = async (paymentID) => {
    try {
      
      const response = await axios.post(
        `${localserver}/OrderStatusUpdate`,
        {
          event_id: localStorage.getItem("eventId"),
          order_status: "cancelled",
          attendee_payment_id: paymentID,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.success) {
        showToast(response.data.message, "success");
        setShowPreviewModal(false);
        refreshSummary();
        fetchOrders();
      }else{
        showToast(response.data.message, "error")
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
      showToast(error, "error");
    }
  };

  const resendSuccessMail = async (attendees_payments_id) => {
    try {
      const response = await axios.post(
        `${localserver}/resend_order_confirmation`,
        {
          attendees_payments_id,
          event_id: localStorage.getItem("eventId"),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.success) {
        showToast(response.data.message, "success");
        return true;
      } else {
        console.error("Error: Failed to update attendee status");
        showToast(response.data.message, "error");
        return false;
      }
    } catch (error) {
      console.error("Error updating attendee status:", error);
      showToast(error, "error");
      return false;
    }
  };

  const handleApplyFilters = () => {
    setSelectedTicketId(filterTicketId);
    setDateFrom(filterDateFrom);
    setDateTo(filterDateTo);
  };

  const handleResetFilters = () => {
    setFilterTicketId("0");
    setFilterDateFrom("");
    setFilterDateTo("");
    setSelectedTicketId("0");
    setDateFrom("");
    setDateTo("");
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  useEffect(() => {
    const init = async () => {
      await fetchTicketList();
      await getOrdersByEventID({ status: "all" }, false);
      await refreshSummary();
      fetchOrders();
    };
    init();
  }, [refreshSummary]);

  const handleHeaderCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    const updatedRows = rows.map((row) => ({
      ...row,
      checked: isChecked,
    }));
    setRows(updatedRows);
  };

  const handleRowCheckboxChange = (index) => (e) => {
    const isChecked = e.target.checked;
    const updatedRows = [...rows];
    updatedRows[index].checked = isChecked;
    setRows(updatedRows);
  };

  const parseFormData = (formData) => {
    try {
      const parsed = JSON.parse(formData || "[]");
      return parsed[0]?.custom_fields || [];
    } catch (error) {
      console.error("Error parsing form_data:", error);
      return [];
    }
  };
  const [handleActionStatus, setHandleAction] = useState(false);
  const handleAction = async (row, action) => {
    const hasPermission = await checkPermission("Orders", "update");
    if (!hasPermission) return;
    
    const attendeeData = row.attendeeData || row || {};
    if (action === "resend") {
      setHandleAction(true);
      await resendSuccessMail(attendeeData.attendee_payment_id);
      setHandleAction(false);
      
    } else if (action === "cancel") {
      
      await cancelOrder(attendeeData.attendee_payment_id || attendeeData.id);
    } else if (action === "edit" || action === "edit-buyer") {
      const editData = {
        id: attendeeData.id || attendeeData.attendee_id || null,
        event_id:
          attendeeData.event_id || localStorage.getItem("eventId") || "",
        form_data:
          attendeeData.form_data ||
          JSON.stringify([{ custom_fields: attendeeData.custom_fields || [] }]),
        guest_data: attendeeData.guest_data || "[]",
        ticket_id:
          attendeeData.ticket_id ||
          attendeeData.ticket_name ||
          attendeeData.tickets ||
          "",
        ticket_name: attendeeData.ticket_name || attendeeData.tickets || "",
        reg_code: attendeeData.reg_code || attendeeData.registrationId || "N/A",
        status: attendeeData.status || "confirmed",
        created_at: attendeeData.created_at || attendeeData.registeredOn || "",
        email: attendeeData.email || "N/A",
        first_name: attendeeData.first_name || "",
        last_name: attendeeData.last_name || "",
        custom_fields:
          attendeeData.custom_fields || parseFormData(attendeeData.form_data),
        isGuest: attendeeData.isGuest || attendeeData.is_guest || false,
        add_ons_data: attendeeData.add_ons_data || "[]",
        buyer_details: attendeeData.buyer_details || "",
        attendee_payment_id: attendeeData.attendee_payment_id,
        ticket_data: attendeeData.ticket_data,
      };
      
      setUpdateAttendeeDetails(editData);
      setUpdateType(action === "edit-buyer" ? "buyer" : "attendee");
      setShowUpdateModal(true);
    }
  };

  const handleRowClick = (row) => {
    const attendeeData = {
      id: row.attendeeData.id || null,
      event_id:
        row.attendeeData.event_id || localStorage.getItem("eventId") || "",
      name: row.nameOfBuyer,
      registrationId: row.attendeeData.reg_code || "N/A",
      orderId: row.orderId || "N/A",
      ticketType: row.tickets || "N/A",
      registeredOn: row.attendeeData.created_at || "",
      email: row.attendeeData.email || "N/A",
      first_name: row.attendeeData.first_name || "",
      last_name: row.attendeeData.last_name || "",
      custom_fields:
        row.attendeeData.custom_fields ||
        parseFormData(row.attendeeData.form_data),
      isGuest: row.attendeeData.is_guest || false,
      buyer_details: row.attendeeData.buyer_details || "",
    };
    
    setSelectedPreviewOrder(attendeeData);
    setShowPreviewModal(true);
  };

  const columns = [
    {
      label: "Order ID",
      field: "orderId",
      sort: "asc",
    },
    {
      label: "Date",
      field: "date",
      sort: "asc",
    },
    {
      label: "Name of Buyer",
      field: "nameOfBuyer",
      sort: "asc",
    },
    {
      label: "Tickets",
      field: "tickets",
      sort: "asc",
    },
    {
      label: "Amount",
      field: "amount",
      sort: "asc",
    },
    {
      label: "Refund / Dues",
      field: "refundOrDues",
      sort: "asc",
    },
    {
      label: "Method",
      field: "method",
      sort: "asc",
    },
    {
      label: "Actions",
      field: "actions",
      sort: false,
    },
  ];

  const tableData = {
    columns,
    rows: rows.map((row, index) => ({
      ...row,
      check: (
        <label>
          <FormCheck
            type="checkbox"
            label=""
            id={`checkbox-permanent-${index}`}
            checked={row.checked}
            onChange={handleRowCheckboxChange(index)}
          />
        </label>
      ),
      actions: (
        <div className="dropdown" style={{padding:0}}>
          <button
            className="btn btn-secondary btn-sm dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
              
          >
            <i className="fa fa-ellipsis-v"></i>
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAction(row, "cancel");
                }}
              >
                Cancel Order
              </button>
            </li>
          </ul>
        </div>
      ),
      clickEvent: (e) => {
        if (
          e.target.closest(".dropdown") ||
          e.target.closest(".dropdown-toggle") ||
          e.target.closest(".dropdown-menu")
        ) {
          return;
        }
        handleRowClick(row);
      },
    })),
    footer: false,
  };

  const fetchPermission = async () => {
    setCheckUserLoading(true);
    try {
      const hasPermission = await checkPermission("Orders", "view");
      if (!hasPermission) return;
    } catch (error) {
      console.error("Error Check Permission:", error);
    } finally {
      setCheckUserLoading(false);
    }
  };

  useEffect(() => {
    fetchPermission();
  }, []);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <ToastMessage />
      {checkUserLoading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
            gap: "16px",
          }}
        >
          <div
            style={{
              width: "48px",
              height: "48px",
              border: "4px solid #f3f4f6",
              borderTopColor: "#184778",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
          <p style={{ color: "#6b7280", fontSize: "14px" }}>
            Loading orders...
          </p>
          <style>
            {`
              @keyframes spin {
                to { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      ) : (
        <div style={{ backgroundColor: "#f9fafb", minHeight: "100vh" }}>
          <div>
            {/* Filter Orders Section - Exact Match with EventAttendees */}
            {/* <div className='filter_div_card' >
              <div className='filter_option_div'  >
                <FaFilter />
                <h3  >Filter Orders</h3>
              </div>

              <div className="row g-3 align-items-end">
                <div className="col-md-3">
                  <label
                    htmlFor="ticketType"
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "8px",
                    }}
                  >
                    Ticket Type:
                  </label>
                  <select
                    id="ticketType"
                    value={filterTicketId}
                    onChange={(e) => setFilterTicketId(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      fontSize: "14px",
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      backgroundColor: "white",
                      color: "#374151",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderColor = "#184778"
                      e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = "#d1d5db"
                      e.currentTarget.style.boxShadow = "none"
                    }}
                  >
                    <option value="0">All Tickets</option>
                    {ticketList.map((ticket) => (
                      <option key={ticket.id} value={ticket.id}>
                        {ticket.ticket_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3">
                  <label
                    htmlFor="dateFrom"
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "8px",
                    }}
                  >
                    Registration From:
                  </label>
                  <input
                    id="dateFrom"
                    type="date"
                    value={filterDateFrom}
                    onChange={(e) => setFilterDateFrom(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      fontSize: "14px",
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      backgroundColor: "white",
                      color: "#374151",
                      transition: "all 0.2s ease",
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderColor = "#184778"
                      e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = "#d1d5db"
                      e.currentTarget.style.boxShadow = "none"
                    }}
                  />
                </div>

                <div className="col-md-3">
                  <label
                    htmlFor="dateTo"
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "8px",
                    }}
                  >
                    Registration To:
                  </label>
                  <input
                    id="dateTo"
                    type="date"
                    value={filterDateTo}
                    onChange={(e) => setFilterDateTo(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      fontSize: "14px",
                      border: "1px solid #d1d5db",
                      borderRadius: "8px",
                      backgroundColor: "white",
                      color: "#374151",
                      transition: "all 0.2s ease",
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderColor = "#184778"
                      e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = "#d1d5db"
                      e.currentTarget.style.boxShadow = "none"
                    }}
                  />
                </div>

                <div className="col-md-3">
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button
                      onClick={handleApplyFilters}
                      className='apply_btn btn'

                    >
                      Apply
                    </button>
                    <button
                      onClick={handleResetFilters}
                      className='reset_btn btn '
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="filter_div_card">
              <div
                className="filter_option_div"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
                onClick={() => setIsOpen(!isOpen)}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <FaFilter />
                  <h3>Filter Orders</h3>
                </div>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#184778",
                    transition: "transform 0.2s ease",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                >
                  <i class="fa fa-angle-down"></i>
                </span>
              </div>

              {isOpen && (
                <div className="filter_body">
                  <div className="row g-3 align-items-end">
                    <div className="col-md-3">
                      <label
                        htmlFor="ticketType"
                        style={{
                          display: "block",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                        }}
                      >
                        Ticket Type:
                      </label>
                      <select
                        id="ticketType"
                        value={filterTicketId}
                        onChange={(e) => setFilterTicketId(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          fontSize: "14px",
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          backgroundColor: "white",
                          color: "#374151",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = "#184778";
                          e.currentTarget.style.boxShadow =
                            "0 0 0 3px rgba(24, 71, 120, 0.1)";
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = "#d1d5db";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <option value="0">All Tickets</option>
                        {ticketList
                          .filter((ticket) => ticket.ticket_status === "onsale")
                          .map((ticket) => (
                            <option key={ticket.id} value={ticket.id}>
                              {ticket.ticket_name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label
                        htmlFor="dateFrom"
                        style={{
                          display: "block",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                        }}
                      >
                        Registration From:
                      </label>
                      <input
                        id="dateFrom"
                        type="date"
                        value={filterDateFrom}
                        onChange={(e) => setFilterDateFrom(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          fontSize: "14px",
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          backgroundColor: "white",
                          color: "#374151",
                          transition: "all 0.2s ease",
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = "#184778";
                          e.currentTarget.style.boxShadow =
                            "0 0 0 3px rgba(24, 71, 120, 0.1)";
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = "#d1d5db";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      />
                    </div>

                    <div className="col-md-3">
                      <label
                        htmlFor="dateTo"
                        style={{
                          display: "block",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                        }}
                      >
                        Registration To:
                      </label>
                      <input
                        id="dateTo"
                        type="date"
                        value={filterDateTo}
                        onChange={(e) => setFilterDateTo(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          fontSize: "14px",
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          backgroundColor: "white",
                          color: "#374151",
                          transition: "all 0.2s ease",
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = "#184778";
                          e.currentTarget.style.boxShadow =
                            "0 0 0 3px rgba(24, 71, 120, 0.1)";
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = "#d1d5db";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      />
                    </div>

                    <div className="col-md-3">
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button
                          onClick={handleApplyFilters}
                          className="apply_btn btn"
                        >
                          Apply
                        </button>
                        <button
                          onClick={handleResetFilters}
                          className="reset_btn btn"
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "20px",
                marginBottom: "24px",
              }}
            >
              <div className="order_inner_card">
                <div className="order_inner_card_div_image">
                  <FaCheckCircle />
                </div>
                <div className="order_inner_card_div">
                  <h4>Confirmed Orders</h4>
                  <p>{statusSummary.confirmed || 0}</p>
                </div>
              </div>

              <div className="order_inner_card">
                <div className="order_inner_card_div_image">
                  <FaRupeeSign />
                </div>
                <div className="order_inner_card_div">
                  <h4>Revenue in INR</h4>
                  <p>
                    {totalRevenue.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </div>
              </div>
            </div>

            <div
              style={{
                backgroundColor: "#ffffff",
                padding: "20px 24px",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                marginBottom: "24px",
                border: "1px solid #e5e7eb",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "4px",
                  alignItems: "center",
                }}
              >
                {[
                  {
                    key: "confirmed",
                    title: "Confirmed",
                    count: statusSummary.confirmed || 0,
                  },
                  {
                    key: "pending",
                    title: "Pending",
                    count: statusSummary.pending || 0,
                  },
                  {
                    key: "blacklisted",
                    title: "Blacklisted",
                    count: statusSummary.blacklisted || 0,
                  },
                  {
                    key: "cancelled",
                    title: "Cancelled",
                    count: statusSummary.cancelled || 0,
                  },
                ].map((tab) => {
                  const isActive = activeTab === tab.key;
                  return (
                    <button
                      key={tab.key}
                      onClick={() => setActiveTab(tab.key)}
                      style={{
                        padding: "12px 20px",
                        border: "none",
                        backgroundColor: isActive ? "#184778" : "transparent",
                        color: isActive ? "#ffffff" : "#666666",
                        fontSize: "14px",
                        fontWeight: "500",
                        cursor: "pointer",
                        borderRadius: "8px",
                        transition: "all 0.2s ease-in-out",
                        marginRight: "8px",
                      }}
                      onMouseEnter={(e) => {
                        if (!isActive) {
                          e.target.style.backgroundColor = "#f3f4f6";
                          e.target.style.color = "#184778";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isActive) {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "#666666";
                        }
                      }}
                    >
                      {tab.title} ({tab.count})
                    </button>
                  );
                })}
                <div style={{ position: "relative", marginLeft: "auto" }}>
                  <i
                    className="fa fa-search"
                    style={{
                      position: "absolute",
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#666666",
                      fontSize: "14px",
                    }}
                  ></i>
                  <input
                    type="text"
                    placeholder="Search Orders..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{
                      padding: "10px 16px 10px 36px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "14px",
                      outline: "none",
                      width: "250px",
                      transition: "border-color 0.2s ease-in-out",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#184778")}
                    onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                padding: "24px",
                border: "1px solid #e5e7eb",
              }}
            >
              <div style={{ overflowX: "auto", borderRadius: "8px" }}>
                <MDBDataTable
                  noBottomColumns
                  className="table table-hover js-basic-example dataTable table-custom spacing5"
                  entriesOptions={[5, 10, 20, 25]}
                  entries={10}
                  paging
                  pagesAmount={5}
                  data={tableData}
                  sortRows={["orderId"]}
                  searching={false}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <PreviewAttendeeOrderModal
        show={showPreviewModal}
        onHide={() => setShowPreviewModal(false)}
        attendee={selectedPreviewOrder}
        onMoreAction={handleAction}
        refreshOrders={fetchOrders}
        handleActionStatus={handleActionStatus}
      />
      <UpdateAttendeeModal
        show={showUpdateModal}
        onHide={() => setShowUpdateModal(false)}
        attendeeDetails={updateAttendeeDetails}
        ticketList={ticketList}
        getAttendeesByEventID={fetchOrders}
        type={updateType}
        setUpdateType={setUpdateType}
      />
    </>
  );
};

export default EventOrderList;